import { Input } from "@/components/ui/input";
import { CustomFieldEntity, CustomFieldType } from "@common/utils/graphql";
import React, {
  ComponentProps,
  ComponentPropsWithoutRef,
  LegacyRef,
} from "react";
import { CustomFieldSelectInput } from "./CustomFieldSelectInput";
import { Checkbox } from "@/components/ui/checkbox";

type IProps = (
  | React.ComponentPropsWithoutRef<typeof Input>
  | (React.ComponentPropsWithoutRef<typeof CustomFieldSelectInput> & {
      onChange: (listOptionId: number) => void;
    })
  | (React.ComponentPropsWithoutRef<typeof Checkbox> & {
      onChange: (value: boolean) => void;
    })
) & {
  customField: CustomFieldEntity;
};

export const CustomFieldInput = React.forwardRef<
  | React.ElementRef<typeof Input>
  | React.ElementRef<typeof CustomFieldSelectInput>
  | React.ElementRef<typeof Checkbox>,
  IProps
>(({ customField, ...props }: IProps, ref) => {
  switch (customField.type) {
    case CustomFieldType.Checkbox:
      return (
        <Checkbox
          {...(props as ComponentProps<typeof Checkbox>)}
          ref={ref as LegacyRef<HTMLButtonElement>}
          checked={props.value as unknown as boolean}
          onCheckedChange={(value: any) => {
            props.onChange?.(value);
          }}
        />
      );
    case CustomFieldType.List:
    case CustomFieldType.MultiLevelList:
      return (
        <CustomFieldSelectInput
          value={props.value as number}
          onSelect={
            props.onChange as ComponentProps<
              typeof CustomFieldSelectInput
            >["onSelect"]
          }
          customField={customField}
        />
      );
    case CustomFieldType.ShortText:
      return (
        <Input
          {...(props as ComponentPropsWithoutRef<typeof Input>)}
          placeholder={`Enter ${customField.name}`}
          ref={ref as LegacyRef<HTMLInputElement>}
        />
      );
    default: {
      console.error(`Unsupported custom field type: ${customField.type}`);
    }
  }
});
